import { IEsgDataPlatform } from '@Domains/Esg/EsgDataPlatform';
import { IEsgDataPlatformFormValues } from './Containers/EsgPlatformFormProvider/types';

export const mapEsgDataPlatformToFormValues = (
  data?: IEsgDataPlatform
): IEsgDataPlatformFormValues => {
  return {
    ...data,
    isAllCompletedTh: false,
    isAllCompletedEn: false,
  } as IEsgDataPlatformFormValues;
};
